import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col, Image } from 'react-bootstrap'
import logo from '@/assets/images/haloo_loader.gif'

const Loader = ({ loading }) => {
  if (loading) {
    return (
      <Container className='loader' fluid>
        <Row>
          <Col>
            <Image src={logo} width='150' height='150' alt='Loading...' />
          </Col>
        </Row>
      </Container>
    )
  }
  return null
}

Loader.defaultProps = {
  loading: false
}

Loader.propTypes = {
  loading: PropTypes.bool
}

export default Loader
